import FormFooter from "../../components/FormFooter";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useContext, useEffect, useState } from "react";
import { MyContext } from "../../context/myContext";
import FormikInput from "../../components/FormikInput";
import { useDispatch, useSelector } from "react-redux";
import {
  addRequest,
  selectRequestError,
  selectWaterType,
  setRequestStatus,
} from "./requestSlice";
import axios from "axios";

const AddRequestForm = () => {
  const { showForm } = useContext(MyContext);
  const [name, setName] = useState("");
  const dispatch = useDispatch();
  const waterType = useSelector(selectWaterType);
  const error = useSelector(selectRequestError);
const [nomadId,setNomadId]=useState(0)
  const formik = useFormik({
    initialValues: {
      code: "",
      waterVolume: "",
      waterType: "",
    },
    validationSchema: Yup.object().shape({
      code: Yup.number()
        .required("کد ملی را وارد کنید")
        .typeError("ده رقم کد ملی را انگلیسی وارد کنید"),
      waterVolume: Yup.number()
        .required("حجم آب را وارد کنید")
        .typeError("به عدد وارد کنید"),
      waterType: Yup.string().required("نوع آب را وارد کنید"),
    }),
    onSubmit: async (values) => {
      newRequest();
      formik.resetForm();
    },
  });

  function newRequest() {
  
    const data = {
      created_at_user_id: localStorage.getItem("userId"),
      nomad_id: nomadId,
      water_type: formik.values.waterType,
      water_volume: formik.values.waterVolume,
      code:formik.values.code
    };
    dispatch(
      addRequest({
        data,
        dispatch,
        waterType,
        formikWaterType: formik.values.waterType,
      }),
    );
  }
useEffect(() => {
    const code = formik.values.code;
    if (String(code).length !== 10) {
        setName('');
        return;
    }

    setNameLoading(true);
    axios.get(`https://api.khedmatashayer-kj.ir/v1/nomad/1?national_code=${code}`)
        .then((response) => {
            setName(response.data?.[0]?.name || '');
            setNomadId(response.data?.[0]?.nomad_id || 0)
        })
        .catch(() => setName(''))
        .finally(() => setNameLoading(false));

}, [formik.values.code]);
  useEffect(() => {
    formik.resetForm();
    setName("");
    dispatch(setRequestStatus({ error: "" }));
    // eslint-disable-next-line
  }, [showForm === false]);
  const [nameLoading, setNameLoading] = useState(false);
//   const handleOnFocusOut = async () => {
//     const code = formik.values.code;
//     if (!code) return;

//     setNameLoading(true);
//     try {
//       const response = await axios.get(
//         `https://api.khedmatashayer-kj.ir/v1/nomad/1?national_code=${code}`,
//       );
//       const nomad = response.data?.[0];
//       setName(nomad?.name || "");
//     } catch (e) {
//       setName("");
//     } finally {
//       setNameLoading(false);
//     }
//   };

  const inputData = [
    { name: "name", placeholder: "نام(براساس کدملی)" },
    { name: "code", placeholder: "کد ملی" },
    { name: "waterVolume", placeholder: "حجم آب درخواستی(لیتر)" },
  ];

  return (
    <form onSubmit={formik.handleSubmit}>
      <div
        className="flex flex-wrap justify-around items-center py-5 [&>div]:form-flex-item [&>div]:flex-col-reverse [&>div]:box-border
            [&_label]:text-right [&_label]:text-[10px] sm:[&_label]:text-xs [&_label]:text-gray-600 [&_label]:mb-1 [&_input]:input-styles
            [&_span]:text-red-600 [&_input]:text-xs sm:[&_input]:text-sm [&_span]:ml-1 [&_p.error]:formik-error"
      >
        <FormikInput
          data={inputData}
          nameInRequest={name}
          formik={formik}
          handleChange={formik.handleChange}
        //   handleOnFocusOut={handleOnFocusOut}
          formType="addReqForm"
           nameLoading={nameLoading} 
        />
        {/*This component represents three inputs*/}
        <div>
          <select
            dir="rtl"
            name="waterType"
            value={formik.values.waterType}
            onChange={formik.handleChange}
            className="select-styles focus:shadow-focusShadow"
          >
            <option value="" disabled>
              نوع آب درخواستی
            </option>
            <option value={1}>آب شرب</option>
            <option value={2}>آب دام</option>
                                    <option value={3}>هر دو</option>

          </select>
          <span className="double-select-arrow top-2/3"></span>
          <label>
            نوع آب<span>*</span>
          </label>
          {formik.touched.waterType && formik.errors.waterType ? (
            <p className="error">{formik.errors.waterType}</p>
          ) : null}
        </div>
        {error ? <p className="server-error">{error}</p> : null}
      </div>
      <FormFooter />
    </form>
  );
};

export default AddRequestForm;
